import HadithExplanationResultItem from './HadithExplanationResultItem';

export default HadithExplanationResultItem;
